import React from 'react'
import { useTrans } from 'hooks'
import { ArchivioDocumentiListingNode, PaginaNode } from '@gql/graphql'
import { CodiceEticoBox, ListingHead, Page } from 'components/organisms'
import styles from './CodiceEticoTemplate.module.sass'
import { PlaceholderReact } from '@components/molecules'

interface Props {
  pagina?: PaginaNode
  documenti: ArchivioDocumentiListingNode[]
  mainContent?: any
  etico?: boolean
}

const CodiceEticoTemplate = (props: Props) => {
  const {
    pagina = undefined,
    documenti = undefined,
    mainContent = undefined,
    etico = false,
  } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        <PlaceholderReact
          contentTypeId={pagina?.model}
          objectId={pagina?.pk}
          pkey={'main'}
          serverSideContent={mainContent}
        />
      </main>
      <CodiceEticoBox documenti={documenti} etico={etico} />
    </Page>
  )
}

export default CodiceEticoTemplate
